import { Card } from "@material-ui/core";
import React, { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import firebase_ from "../../../../firebase/firebase";

function TaskList() {
  const [taskList, setTaskList] = useState([]);
  const email = useParams();
  const db = firebase_.firestore();
  async function fetchTaskList() {
    setTaskList([]);
    console.log("email", email.email);
    await db
      .collection("task")
      .where("userEmail", "==", email.email)
      .get()
      .then((res) => {
        res.forEach((item) => {
          setTaskList((taskList) => [...taskList, item.data()]);
        });
      })
      .catch((err) => {
        console.log("Project error ", err);
      });
  }
  useEffect(() => {
    fetchTaskList();
  }, []);

  return (
    <div>
      <div className="task-list">
        <h1>Hello</h1>
        {taskList.map((data, index) => {
          return (
            <Card className="users-card" key={index}>
              <p>{data["taskDescription"]}</p>
              <p>{data["project"]}</p>
              <p>{data["taskDate"]}</p>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

export default TaskList;
